import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'public-review-dialog',
  template: `
    <mat-card class="review-dialog-card">
      <mat-card-title class="dialog-title">Share Your Review Online</mat-card-title>
      <mat-card-content>
        <p>Your feedback is valuable. Would you like to post your review on one of the following platforms?</p>
        
        <div class="platform-grid">
          <div 
            *ngFor="let platform of reviewPlatforms" 
            class="platform-item" 
            (click)="openPlatform(platform)"
          >
            <img 
              [src]="getIcon(platform)" 
              [alt]="platform + ' icon'" 
              class="platform-icon"
            >
            <span class="platform-name">{{ capitalize(platform) }}</span>
          </div>
        </div>
      </mat-card-content>
      
      <mat-card-actions align="end">
        <button 
          mat-stroked-button 
          mat-dialog-close 
          class="cancel-button"
        >
          <mat-icon>close</mat-icon>
          No, Thanks
        </button>
      </mat-card-actions>
    </mat-card>
  `,
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
  ],
  styleUrls: ['./public-review-dialog.component.scss']
})
export class PublicReviewDialog {
  reviewLinks: { [key: string]: string };
  reviewPlatforms: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PublicReviewDialog>
  ) {
    this.reviewLinks = data;
    this.reviewPlatforms = Object.keys(this.reviewLinks);
    
    // Ensure Google is the first option if it exists
    this.reviewPlatforms.sort((a, b) => {
      if (a === 'google') return -1;
      if (b === 'google') return 1;
      return 0;
    });
  } 

  capitalize(platform: string): string {
    return platform.charAt(0).toUpperCase() + platform.slice(1);
  }

  getIcon(platform: string): string {
    const iconMap: { [key: string]: string } = {
      'google': 'assets/icons/google-logo.png',
      'yelp': 'assets/icons/yelp-logo.png',
      'meta': 'assets/icons/facebook-logo.png',
      'default': 'assets/icons/default-logo.png'
    };
    return iconMap[platform] || iconMap['default'];
  }

  openPlatform(platform: string): void {
    const url = this.reviewLinks[platform];
    if (url) {
      window.location.href = url;
    }
  }
}